<template>
  <router-view class="view"></router-view>
</template>

<script>
export default {
  name: "App",
  created () {
    this.$store.dispatch('getNanoid');
  },
};
</script>

<style lang="scss">
  .card-body {
    position: relative;
    .mask-edit{
      background: #ffffff80;
      position: absolute;
      inset: 0;
      display: grid;

      .bg-load-blue {
        background-color: #321fdb !important;
      }
    }
  }
  // Import Main styles for this application
  @import "assets/scss/style";
  .justify-content-evenly{
    justify-content: space-evenly;
  }
  .view > div {
    transition: height 0.2s;
  }
  .v-select{
    .vs__selected-options{
      flex-wrap: inherit;
    }
    &:not(.vs--open ){
      .vs__selected{
        width: 99%;
      }
      .vs__search{
        width: 1%;
      }
    }
    &.is-invalid{
      input::placeholder {
        color: #e55353;
      }
      .vs__actions{
        svg{
          fill: #e55353;
        }
      }
      .vs__dropdown-toggle {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23e55353' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23e55353' stroke='none'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
        background-position: right calc(1.575em + 0.1875rem) center;
        border-color: #e55353;
      }
      .invalid-feedback{
        display: block;
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #e55353;
      }
    }
  }
  .info_text{
    color: #adadad;
    margin-top: -1rem;
    margin-left: 0.5rem;
    font-size: 13px;
  }

  .gap-1{
    gap: 0.25rem !important;
  }
  .gap-2{
    gap: 0.5rem !important;
  }
  .gap-3{
    gap: 1rem !important;
  }
  .gap-4{
    gap: 1.5rem !important;
  }
  .gap-5{
    gap: 3rem !important;
  }
</style>
